import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import {
  selectTask,
  selectTasksLoaded,
  selectTasksLoading,
  selectTaskSubmitLoading,
} from "../../../../redux/educator/selector";
import { editTask, getTaskById } from "../../../../redux/educator/actions";

const mapStateToProps = (state: StateType) => ({
  task: selectTask(state),
  loading: selectTasksLoading(state),
  loaded: selectTasksLoaded(state),
  submitLoading: selectTaskSubmitLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getTaskById,
      editTask,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
